import { render, staticRenderFns } from "./SourceProfile.vue?vue&type=template&id=12464f1e&scoped=true"
import script from "./SourceProfile.vue?vue&type=script&lang=js"
export * from "./SourceProfile.vue?vue&type=script&lang=js"
import style0 from "./SourceProfile.vue?vue&type=style&index=0&id=12464f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12464f1e",
  null
  
)

export default component.exports